<template>
	<div class="claim-title-block">
		<h4 class="claim-title-text">
			<slot></slot>
		</h4>
		<p v-if="$slots.hint" class="claim-title-hint">
			<slot name="hint"></slot>
		</p>
	</div>
</template>

<script>
export default {
	name: "ClaimTitle"
};
</script>

<style lang="scss" scoped>
.claim-title-block {
	margin-bottom: 0.625rem;
}

.claim-title-text {
	font-size: 0.9375rem;
	font-weight: 600;
	letter-spacing: 0.005em;
	line-height: 1.4;
	color: rgba(0, 0, 0, 0.85);
	margin: 0;
}

.claim-title-hint {
	font-size: 0.8125rem;
	line-height: 1.5;
	color: rgba(0, 0, 0, 0.48);
	margin: 0.3rem 0 0;
	font-weight: 400;
	padding-left: 0.875rem;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		left: 0.125rem;
		top: 0.45em;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background: rgba(76, 175, 80, 0.55);
		flex-shrink: 0;
	}
}
</style>
